'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var IconWrapper = require('../IconWrapper.js');

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React__default.createElement(IconWrapper.default, _extends({
    viewbox: 18,
    type: "close"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M9,7.39046609 L12.9747395,3.34850231 C13.4295385,2.88601136 14.1836008,2.88201551 14.6501485,3.3485632 C15.1199489,3.81836356 15.1167258,4.56521943 14.6502147,5.02397754 L10.594678,9.0121147 L14.6603403,13.1465391 C15.1190955,13.6130531 15.112846,14.3693815 14.6540956,14.8281319 L14.8293481,14.6528794 C14.367144,15.1150835 13.6102486,15.1139207 13.1477605,14.6591188 L9,10.5802905 L4.85223947,14.6591188 C4.38975143,15.1139207 3.63285596,15.1150835 3.17065194,14.6528794 L3.34590439,14.8281319 C2.88715397,14.3693815 2.88090452,13.6130531 3.33965971,13.1465391 L7.40532199,9.0121147 L3.34978529,5.02397754 C2.88327416,4.56521943 2.88005111,3.81836356 3.34985148,3.3485632 C3.81639916,2.88201551 4.57046153,2.88601136 5.02526052,3.34850231 L9,7.39046609 Z"
  }));
};

process.env.NODE_ENV !== "production" ? SvgClose.propTypes = {
  size: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string
} : void 0;
SvgClose.IsIcon = true;

exports.default = SvgClose;
